/** Embed origins whose player implements the player.js postMessage protocol. */
const PLAYER_JS_ORIGINS: ReadonlySet<string> = new Set(['https://player.mux.com']);

function getOrigin(url: string): string | undefined {
	try {
		return new URL(url).origin;
	} catch {
		return undefined;
	}
}

/**
 * Pauses the player inside an embed iframe without reloading it, so its poster and position stay on
 * screen. Returns `false` when the embed's player has no known control protocol, leaving the caller to
 * stop playback some other way.
 */
export function pauseEmbed(iframe: HTMLIFrameElement, embedUrl: string): boolean {
	const origin = getOrigin(embedUrl);
	if (!origin || !PLAYER_JS_ORIGINS.has(origin)) return false;

	iframe.contentWindow?.postMessage(
		JSON.stringify({ context: 'player.js', version: '0.0.11', method: 'pause' }),
		origin,
	);
	return true;
}
